import * as React from "react";

import { ColorSuccess } from "./theme";

export const SuccessIcon = ({
  fill,
  width,
  height,
}: {
  fill?: string;
  width?: string;
  height?: string;
}) => {
  return (
    <svg
      width={width || "16"}
      height={height || "16"}
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_10675_44704)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 0C7.62344 0 0 7.62344 0 17C0 26.3766 7.62344 34 17 34C26.3766 34 34 26.3766 34 17C34 7.62344 26.3766 0 17 0Z"
          fill={fill || ColorSuccess.main}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.2207 11.2708C25.6324 11.6825 25.6324 12.3599 25.2207 12.7716L15.2598 22.7325C15.0539 22.9384 14.7816 23.0446 14.5094 23.0446C14.2371 23.0446 13.9648 22.9384 13.759 22.7325L8.77852 17.7521C8.3668 17.3403 8.3668 16.663 8.77852 16.2513C9.19023 15.8396 9.86758 15.8396 10.2793 16.2513L14.5094 20.4813L23.7199 11.2708C24.1316 10.8524 24.809 10.8524 25.2207 11.2708Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_10675_44704">
          <rect width="34" height="34" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
